import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveList } from '../actions/RichListActions.js';
import { setActiveTimescale } from '../actions/TimeSeriesActions.js';

import LineChart from './LineChart';

const ChartCard = () => {
  const dispatch = useDispatch();

  const richLists = useSelector((state) => state.richLists);
  const { activeList } = richLists;

  const timeSeries = useSelector((state) => state.timeSeries);
  const { activeTimescale } = timeSeries;

  return (
    <div className="flex flex-col flex-grow w-full bg-white rounded-md py-3 px-4">
      <h2 className="w-full font-bold text-2xl text-yellow-600">
        {activeList === 'AFR2020'
          ? 'AFR'
          : activeList === 'Oz2020'
          ? 'The Australian'
          : 'Forbes'}{' '}
        Total Rich List Value (AUD)
      </h2>
      <div className="mt-2 mb-4 text-xs font-mono flex justify-between">
        <div>
          <button
            onClick={() => dispatch(setActiveList('AFR2020'))}
            className={`focus:outline-none ${
              activeList === 'AFR2020'
                ? 'no-underline font-bold text-yellow-600'
                : 'underline'
            }`}
          >
            AFR
          </button>{' '}
          |{' '}
          <button
            onClick={() => dispatch(setActiveList('Oz2020'))}
            className={`focus:outline-none ${
              activeList === 'Oz2020'
                ? 'no-underline font-bold text-yellow-600'
                : 'underline'
            }`}
          >
            AUSTRALIAN
          </button>{' '}
          |{' '}
          <button
            onClick={() => dispatch(setActiveList('FORBES2021'))}
            className={`focus:outline-none ${
              activeList === 'FORBES2021'
                ? 'no-underline font-bold text-yellow-600'
                : 'underline'
            }`}
          >
            FORBES
          </button>
        </div>
        <div>
          <button
            onClick={() => dispatch(setActiveTimescale('All'))}
            className={`focus:outline-none ${
              activeTimescale === 'All'
                ? 'no-underline font-bold text-yellow-600'
                : 'underline'
            }`}
          >
            All
          </button>{' '}
          |{' '}
          <button
            onClick={() => dispatch(setActiveTimescale('5 Years'))}
            className={`focus:outline-none ${
              activeTimescale === '5 Years'
                ? 'no-underline font-bold text-yellow-600'
                : 'underline'
            }`}
          >
            5 Years
          </button>{' '}
          |{' '}
          <button
            onClick={() => dispatch(setActiveTimescale('1 Year'))}
            className={`focus:outline-none ${
              activeTimescale === '1 Year'
                ? 'no-underline font-bold text-yellow-600'
                : 'underline'
            }`}
          >
            1 Year
          </button>
        </div>
      </div>
      <LineChart />
    </div>
  );
};

export default ChartCard;
